export type SnapshotPatch={v:2|3|4|5;b:number;r:number;d:string;p:string[][];c:unknown[][]};

// Atomic copy-on-write; invalid revisions and paths require a fresh snapshot.
export function applyRevisionPatch<T extends {revision:number;drawId:string}>(current:T|null,patch:SnapshotPatch,version:2|3|4|5,metricsOnly=false):T|null{
 if(!current||patch.v!==version||patch.b!==current.revision||(metricsOnly?patch.r!==patch.b:patch.r<=patch.b))return null;
 const clones=new WeakMap<object,Record<string,unknown>>();
 const clone=(node:object):Record<string,unknown>=>{
  const known=clones.get(node);if(known)return known;
  const result=(Array.isArray(node)?[...node]:{...node}) as Record<string,unknown>;
  clones.set(node,result);clones.set(result,result);return result;
 };
 const root=clone(current);
 for(const change of patch.c){
  const shape=patch.p[change[0] as number];if(!shape?.length)return null;
  const width=shape.filter(k=>k==='*').length+1;
  if((change.length-1)%width!==0)return null;
  for(let start=1;start<change.length;start+=width){
  let node=root,position=start;
  for(let i=0;i<shape.length;i++){
   const field=shape[i],key=field==='*'?change[position++]:field;
   if(field==='*'&&(!Array.isArray(node)||!Number.isInteger(key)))return null;
   if(typeof key!=='string'&&typeof key!=='number'||['__proto__','prototype','constructor'].includes(String(key)))return null;
   const last=i===shape.length-1;
   if(!Object.hasOwn(node,key)&&!(last&&Array.isArray(node)&&Number.isInteger(key)&&key===node.length))return null;
   if(last)node[key]=change[position];
   else {const child=node[key];if(typeof child!=='object'||child===null)return null;node[key]=node=clone(child);}
  }
  }
 }
 return root.revision===patch.r&&root.drawId===patch.d?root as unknown as T:null;
}
